<template>
  <div class="matching-info t-text">
    <h3>{{ $t('matchingView.main.fairness_headline') }}</h3>
    <p>{{ $t('matchingView.main.fairness_content') }}</p>
    <h3>{{ $t('matchingView.main.matching_headline') }}</h3>
    <p>{{ $t('matchingView.main.matching_content') }}</p>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.matching-info {
  padding: 3.125rem;
  text-align: center;
}
</style>
